import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '@standardnotes/utils';
import RadioIndicator from './RadioIndicator';
const StyledRadioInput = ({ className, ...props }) => {
    return (_jsxs("div", { className: classNames('flex', className), children: [_jsx("input", { type: "radio", className: "h-0 w-0 opacity-0", ...props }), _jsx(RadioIndicator, { checked: !!props.checked })] }));
};
export default StyledRadioInput;
